import React from "react";
import { downloadPDF } from "../../../helpers/pdf";

import { downloadBlack, downloadWhite } from "../../../images";
import { ReaderDoc } from "../PageContents/index";

type Props = {
    doc: ReaderDoc;
    isDark: boolean;
};

export default class Download extends React.Component<Props> {
    onClick = () => downloadPDF(this.props.doc.id);

    render() {
        const { isDark } = this.props;
        return (
            <img
                alt="ڈاؤنڈلوڈ"
                onClick={this.onClick}
                src={isDark ? downloadWhite : downloadBlack}
            />
        );
    }
}
